import React from 'react'
import Link from 'jl-design-system/elements/link/Link'
import logo from 'jl-design-system/assets/john-lewis/john-lewis-and-partners-default.svg'
import './Header.scss'

export default function Header() {
  return (
    <header className="header">
      <div className="header__container">
        <Link to="/#homepage" external className="header__logo" data-testid="header-link">
          <img src={logo} alt="John Lewis & Partners" />
        </Link>
      </div>
    </header>
  )
}
